var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FF0508"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8443 23.9776C51.0295 23.7926 51.1766 23.5728 51.2769 23.3309C51.3773 23.0891 51.429 22.8298 51.4292 22.5679C51.4294 22.306 51.3779 22.0467 51.2779 21.8047C51.1778 21.5627 51.0311 21.3428 50.846 21.1575C50.6609 20.9722 50.4412 20.8252 50.1993 20.7248C49.9574 20.6244 49.6982 20.5727 49.4363 20.5725C49.1744 20.5724 48.9151 20.6238 48.6731 20.7239C48.4311 20.8239 48.2111 20.9707 48.0259 21.1557L36 33.1816L23.9776 21.1557C23.6034 20.7815 23.0959 20.5713 22.5667 20.5713C22.0375 20.5713 21.5299 20.7815 21.1557 21.1557C20.7815 21.5299 20.5713 22.0375 20.5713 22.5667C20.5713 23.0959 20.7815 23.6034 21.1557 23.9776L33.1816 36L21.1557 48.0224C20.9704 48.2077 20.8235 48.4277 20.7232 48.6698C20.6229 48.9118 20.5713 49.1713 20.5713 49.4333C20.5713 49.6954 20.6229 49.9548 20.7232 50.1969C20.8235 50.439 20.9704 50.659 21.1557 50.8443C21.5299 51.2185 22.0375 51.4287 22.5667 51.4287C22.8287 51.4287 23.0882 51.3771 23.3303 51.2768C23.5723 51.1765 23.7923 51.0296 23.9776 50.8443L36 38.8184L48.0259 50.8443C48.4001 51.218 48.9074 51.4278 49.4363 51.4275C49.9652 51.4272 50.4723 51.2168 50.846 50.8425C51.2197 50.4683 51.4295 49.961 51.4292 49.4321C51.4289 48.9032 51.2185 48.3962 50.8443 48.0224L38.8184 36L50.8443 23.9776Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.31b57e29a6088b2f3db4c0f3ab5c0fd7.svg";
export { ForwardRef as ReactComponent };